<div>
    <section class="header blurb">
        <a ng-class="{link: hasContents}" ng-click="onHeaderClick()">
            <h1><span class="regno">{{workflow.UniqueRegistrationNumber}}</span> {{workflow.Title}}</h1>
        </a>
        <p class="description" ng-if="showDescription">{{workflow.Description}}</p>
    </section>
</div>